/*********************************************************************
* © Copyright IBM Corp. 2024
*********************************************************************/
import React, {CSSProperties} from 'react'
import {ListProps, RowItem} from '.'
import styles from '../style/list.css'

export function ListHeader<Item extends RowItem>({columnSpecs}: ListProps<Item>) {
  return (
    <div className={styles['list__header']}>
      {columnSpecs.map((c) => {
        let elementStyles: CSSProperties | undefined
        if (c.width) {
          elementStyles = {
            width: c.width,
            flexGrow: 0,
            flexShrink: 0
          }
        }

        const {HeaderComponent} = c
        return (
          HeaderComponent && (
            <div key={c.id} style={elementStyles} className={styles['list__header__column']}>
              <HeaderComponent {...c} />
            </div>
          )
        )
      })}
    </div>
  )
}
